/* eslint-disable array-callback-return */
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";

export default function Auth() {
  const getRoutes = (routes: any[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else if (prop.layout === "/") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      }
    });
  };
  return (
    <Routes>
      {getRoutes(routes)}
      <Route
        path="/"
        element={<Navigate to="/auth/login" replace />}
      />
    </Routes>
  );
}

